import api from '../../util/api.js'
// initial state
const state = {
  contactBoxShow: false,
  trailBoxShow: false,
  isAgreeUseCookie: true,
  isLoginSuccess: false,
  searchEnable: []
}

// getters
const getters = {}

// actions
const actions = {
  contactBoxShowChange(context) {
    //这里的context和我们使用的$store拥有相同的对象和方法
    context.commit('contactBoxShowChange');
    //你还可以在这里触发其他的mutations方法
  },
  trailBoxShowChange(context) {
    context.commit('trailBoxShowChange');
  },
  changeCookie(context,{opType = 3} = {}) {
    api.policy.saveAgreeCookie({opType}).then(({data}) => {
      context.commit('changeCookie',{bool: data.data})
    })
  },
   //各个栏目的数据
   searchEnable(context) {
		api.index.searchEnable().then(res => {
			if (res.data.code === "success") {
				const data = res.data.data;
				context.commit('searchEnable',data)
			}
		})
	}
}
// mutations
const mutations = {
  contactBoxShowChange(state) {
    //这里的state对应着上面这个state
    state.contactBoxShow = !state.contactBoxShow;
    window.document.getElementsByTagName('html').item(0).className = state.contactBoxShow ? 'noscroll' : '';
    //你还可以在这里执行其他的操作改变state
  },
  trailBoxShowChange(state) {
    state.trailBoxShow = !state.trailBoxShow;
    window.document.getElementsByTagName('html').item(0).className = state.trailBoxShow ? 'noscroll' : '';
  },
  changeCookie(state,{bool}) {
    state.isAgreeUseCookie = bool;
  },
  changeState(state,{bool}) {
    state.isLoginSuccess = bool;
  },
  searchEnable(state,data) {
	  state.searchEnable = data
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Index.js